var BuildService = /** @class */ (function () {
    function BuildService(api) {
        var _this = this;
        this.version = function () { return _this.API.get('/platform/version'); };
        this.request = function (app, platform, version, buildNumber, meta) {
            if (version === void 0) { version = null; }
            if (meta === void 0) { meta = {}; }
            var url = '/build/v2';
            var build = {
                app: app,
                platform: platform,
                meta: meta,
            };
            if (version && version !== '') {
                build.version = version;
            }
            if (buildNumber && buildNumber !== '') {
                build.build_number = buildNumber;
            }
            return _this.API.put(url, build);
        };
        this.listByVersion = function (appId, version) {
            if (version === void 0) { version = { major: 0, minor: 0 }; }
            var url = "/build/".concat(appId, "/").concat(version === null || version === void 0 ? void 0 : version.major, ".").concat(version === null || version === void 0 ? void 0 : version.minor, ".x");
            return _this.API.get(url);
        };
        this.getDownloadLink = function (buildId, duration) {
            var url = "/build/".concat(buildId, "/download?duration=").concat(duration);
            return _this.API.get(url);
        };
        this.getErrorLog = function (buildId) {
            var url = "/build/".concat(buildId, "/errors");
            return _this.API.get(url);
        };
        this.getPublishedDates = function (appId) {
            var url = "/build/success/".concat(appId);
            return _this.API.get(url);
        };
        this.API = api;
    }
    return BuildService;
}());
export { BuildService };
